import { render, staticRenderFns } from "./ListInstructor.vue?vue&type=template&id=1f884f21&"
import script from "./ListInstructor.vue?vue&type=script&lang=js&"
export * from "./ListInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports